<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <p class="entity-page-title text-white fw-bold lh-sm mb-1">Projects</p>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              View and manage all your projects across the platform.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end"
              data-bs-toggle="modal"
              data-bs-target="#create_project"
            >
               <i class="bi bi-plus-circle-fill me-2 text-white"></i>
              Create Project
            </button>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Total Projects
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metrics.total_projects }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-folder2-open"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Active Streams
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metrics.active_streams }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-bar-chart-fill"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Pending Syncs
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metrics.pending_syncs }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-arrow-repeat"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

  <!-- Loading state -->
  <div v-if="is_loading" class="d-flex align-items-center gap-2 text-secondary mb-3">
    <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
    <span>Loading projects…</span>
  </div>

  <!-- Empty state -->
  <div v-else-if="!projects.length" class="card border border-purple border-opacity-50 shadow-sm rounded-4">
    <div class="card-body p-2 p-lg-3 d-flex flex-column align-items-center justify-content-center text-center gap-3">
      <div class="entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center p-2 px-3">
        <i class="bi bi-folder2-open fs-3 opacity-75"></i>
      </div>
      <div>
        <p class="fw-bold text-x mb-1">No Projects Yet</p>
        <p class="text-secondary text-xs mb-0">
          Get started by creating your first project to manage streams, syncs, and more.
        </p>
      </div>
      <button
        type="button"
        class="btn btn-primary-dark btn-sm rounded-3 px-3 py-2 text-xs d-inline-flex align-items-center gap-2 shadow-lg"
        data-bs-toggle="modal"
        data-bs-target="#create_project"
      >
        <i class="bi bi-plus-circle-fill"></i>
        Create Project
      </button>
    </div>
  </div>

  <!-- Populated state -->
  <div v-else class="row gap-0 g-lg-1">
    <div v-for="project in projects" :key="project.id" class="col-12 col-md-4 col-xl-3 mt-4" :id="'project-' + project.id">
      <div class="card-p border border-purple border-opacity-50 rounded-4 h-100">
        <div class="card-body p-4 d-flex flex-column ">
          <div class="d-flex align-items-start justify-content-between mb-3">
            <div class="d-flex align-items-start justify-content-between gap-1 rounded-3 p-1 px-2" :class="project.icon_bg">
              <i class="bi fs-5" :class="project.icon"></i>
            </div>
            <span class="badge rounded-pill fw-bold" :class="project.status_class">{{ project.status }}</span>
          </div>

          <div>
            <div class="fw-bold mb-1 text-x">{{ project.title }}</div>
          </div>

          <p class="text-dark mb-2 text-xs">
            {{ project.description }}
          </p>

          <div class="mt-auto">
            <hr class="text-secondary opacity-25 my-2">
            <div class="d-flex flex-column gap-1 mb-2 text-secondary small">
              <div class="d-flex align-items-center gap-2 text-xs">
                <i class="bi bi-calendar3"></i>
                <span>Created {{ project.created }}</span>
              </div>
              <div class="d-flex align-items-center gap-2 text-xs">
                <i class="bi bi-person"></i>
                <span>Admin: {{ project.admin }}</span>
              </div>
              <button
                type="button"
                class="btn pm-assigned-users-link text-xs d-inline-flex align-items-center gap-2"
                data-bs-toggle="modal"
                data-bs-target="#assigned_users_modal"
                @click="open_assigned_users_modal(project)"
              >
                <i class="bi bi-people"></i>
                <span>{{ assigned_users_label(project) }}</span>
              </button>
            </div>

            <div class="d-flex align-items-center gap-2">
              <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-3 py-2 mt-1 w-70 " 
              @click="view_project(project)">
                View
              </button>
             <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-3 py-2 mt-1 w-70 " 
                data-bs-toggle="modal"
                data-bs-target="#users_modal"
                @click="open_users_modal(project)">
                <i class="bi bi-people-fill"></i>
              </button>
              <button type="button" class="btn btn-light pm-gear-btn rounded-3 d-inline-grid" aria-label="Project settings"
                data-bs-toggle="modal"
                data-bs-target="#edit_project"
                @click="open_edit_project_modal(project)">
                <i class="bi bi-pencil-fill"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

<!-- Create Project Modal -->
<teleport to="body">
  <div class="modal fade" id="create_project" tabindex="-1" aria-labelledby="create_project_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="create_project_label">
            Create Project
          </p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="modal-form-group form-group mb-3">
            <label for="project_name" class="modal-form-label form-label text-xxs">
              Project Name:
            </label>
            <input
              type="text"
              id="project_name"
              v-model="project_name"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              placeholder="Enter Project Name Here" />
            <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">
              Please enter a name for the project
            </small>
          </div>
          <div class="modal-form-group form-group mb-3">
            <label for="project_description" class="modal-form-label form-label text-xxs">
              Project Description:
            </label>
            <input
              type="text"
              id="project_description"
              v-model="project_description"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              placeholder="Enter Project Description Here" />
            <small class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">
              Please enter a description for the project
            </small>
          </div>
          <div class="modal-form-group form-group mb-3">
            <label for="project_type" class="modal-form-label form-label text-xxs">
              Project Type:
            </label>
            <select
              id="project_type"
              v-model="selected_project_type"
              class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm">
              <option value="" disabled hidden>Select Type</option>
              <option v-for="type in project_types" :key="type.id" :value="type.id">
                {{ type.project_type }}
              </option>
            </select>
            <small class="text-danger p-2 text-xxs fw-bold d-none project-type-messages">
              Please select a project type
            </small>
          </div>
          <div class="form-check mb-3">
            <input
              id="enable_compliance_task"
              v-model="enable_compliance_task"
              class="form-check-input pm-purple-check"
              type="checkbox" />
            <label class="form-check-label text-xs" for="enable_compliance_task">
              Enable Compliance Tasks
            </label>
          </div>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
             class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
            @click="create_project">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Assigned Users Modal -->
<teleport to="body">
  <div class="modal fade" id="assigned_users_modal" tabindex="-1" aria-labelledby="assigned_users_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs mb-0" id="assigned_users_modal_label">
            Assigned Users <span v-if="selected_project?.title" class="fw-normal">- {{ selected_project.title }}</span>
          </p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div v-if="assigned_users_loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
            <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
            <span>Loading assigned users...</span>
          </div>
          

          <div v-else-if="assigned_users.length" class="d-flex flex-column gap-2">
            <div
            
              v-for="user in assigned_users"
              :key="user.id"
              class="pm-assigned-user-card d-flex align-items-center justify-content-between gap-2"
            >
            
            
              <div class="d-flex align-items-center gap-2 overflow-hidden">
                <div class="pm-assigned-user-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
                  <i class="bi bi-person-fill"></i>
                </div>
                <div class="overflow-hidden">
                  <div class="pm-assigned-user-name text-truncate">{{ user.name }}</div>
                  <div class="pm-assigned-user-email text-truncate">{{ user.email || user.role }}</div>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary-dark btn-sm rounded-small shadow-sm text-xs"
                @click="unassign_user_from_project(user)"
              >
                Unassign
              </button>
            </div>
          </div>

          <div v-else class="text-center text-secondary text-xs py-4">
            No assigned users.
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="users_modal" tabindex="-1" aria-labelledby="users_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs mb-0" id="users_modal_label">
            Users <span v-if="selected_project?.title" class="fw-normal">- {{ selected_project.title }}</span>
          </p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div v-if="users_loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
            <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
            <span>Loading users...</span>
          </div>
          

         <div v-else-if="users.length" class="d-flex flex-column gap-3">

           <input
                    v-model="user_search"
                    type="search"
                    class="form-control text-xxs rounded-small p-2 mb-2"
                    placeholder="Search user"
                  >
                  
                    <div
                      v-if="!filtered_users.length"
                      class="text-secondary text-xxs px-2 py-2"
                    >
                      No users match your search.
         </div>
                  
      
          <div
           
            v-for="user in filtered_users"
            :key="user.id"
            class="pm-assigned-user-card d-flex align-items-center justify-content-between gap-2"
          >
            <div class="d-flex align-items-center gap-2 overflow-hidden">
              <div class="pm-assigned-user-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
                <i class="bi bi-person-fill"></i>
              </div>

              <div class="overflow-hidden">
                <div class="pm-assigned-user-name text-truncate">
                  {{ user.name }}
                </div>

                <div class="pm-assigned-user-email text-truncate">
                  {{ user.email }}
                </div>
              </div>
            </div>
             
            <div class="form-check form-switch m-0">
             
              <input
                class="form-check-input"
                type="checkbox"
                :checked="user_selected(user.id)"
                :disabled="is_user_toggle_loading(user.id)"
                @change="on_user_toggle(user, $event)"
              />
              Assigned
            </div>
          </div>
        </div>


          <div v-else class="text-center text-secondary text-xs py-4">
            No assigned users.
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Edit Project Modal -->
<teleport to="body">
  <div class="modal fade" id="edit_project" tabindex="-1" aria-labelledby="edit_project_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs mb-0" id="edit_project_label">
            Edit Project
          </p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="modal-form-group form-group mb-3">
            <label for="edit_project_name" class="modal-form-label form-label text-xxs">
              Project Name:
            </label>
            <input
              type="text"
              id="edit_project_name"
              v-model="edit_project_name"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              placeholder="Enter Project Name Here" />
          </div>

          <div class="modal-form-group form-group mb-3">
            <label for="edit_project_description" class="modal-form-label form-label text-xxs">
              Project Description:
            </label>
            <input
              type="text"
              id="edit_project_description"
              v-model="edit_project_description"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
              placeholder="Enter Project Description Here" />
          </div>

          <div class="modal-form-group form-group mb-3">
            <label for="edit_project_type" class="modal-form-label form-label text-xxs">
              Project Type:
            </label>
            <select
              id="edit_project_type"
              v-model="edit_selected_project_type"
              class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm">
              <option value="" disabled hidden>Select Type</option>
              <option v-for="type in project_types" :key="type.id" :value="type.id">
                {{ type.project_type }}
              </option>
            </select>
          </div>

          <div class="form-check mb-3">
            <input
              id="edit_enable_compliance_task"
              v-model="edit_enable_compliance_task"
              class="form-check-input pm-purple-check"
              type="checkbox" />
            <label class="form-check-label text-xs" for="edit_enable_compliance_task">
              Enable Compliance Tasks
            </label>
          </div>
        </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
             class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
            @click="update_project"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>
